module.exports = __webpack_public_path__ + "static/member-profile-swamy.jpg-c8a7098392caaab25a11aad5e3449b1e.jpg";